export default __webpack_public_path__ + "static/media/Logo-5bits.cf338787.svg";